/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Warranty_TermsInputs */

const en_case_doc_warranty_terms = /** @type {(inputs: Case_Doc_Warranty_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warranty terms`)
};

const pt_br2_case_doc_warranty_terms = /** @type {(inputs: Case_Doc_Warranty_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termo de garantia`)
};

/**
* | output |
* | --- |
* | "Warranty terms" |
*
* @param {Case_Doc_Warranty_TermsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_warranty_terms = /** @type {((inputs?: Case_Doc_Warranty_TermsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Warranty_TermsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_warranty_terms(inputs)
	return pt_br2_case_doc_warranty_terms(inputs)
});